import * as XLSX from "xlsx";

// eslint-disable-next-line
export const exportCSV = (filename: string, rows: Record<string, any>[]) => {
  const headers = Object.keys(rows[0]);

  const csv = [
    headers.join(","),
    ...rows.map((row) =>
      headers
        .map((header) => {
          const value = row[header] ?? "";
          return `"${String(value).replace(/"/g, '""')}"`;
        })
        .join(","),
    ),
  ].join("\n");

  const blob = new Blob([csv], {
    type: "text/csv;charset=utf-8;",
  });

  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = `${filename}.csv`;
  link.click();

  URL.revokeObjectURL(url);
};

// eslint-disable-next-line
export const exportEXCEL = (filename: string, rows: Record<string, any>[]) => {
  const worksheet = XLSX.utils.json_to_sheet(prepareRows(rows));
  const stringColumns = new Set(["Sport KO", "Line", "Final_score", "hit_time"]);

  const range = XLSX.utils.decode_range(worksheet["!ref"]!);

  // Read the header row (row 0) and force matching columns to strings
  for (let C = range.s.c; C <= range.e.c; C++) {
    const headerCell = worksheet[XLSX.utils.encode_cell({ r: 0, c: C })];
    if (!headerCell || !stringColumns.has(headerCell.v)) continue;

    for (let R = 1; R <= range.e.r; R++) {
      const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = worksheet[cellRef];
      if (!cell) continue;

      cell.t = "s";
      cell.v = String(cell.v ?? "");
    }
  }
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

  XLSX.writeFile(workbook, `${filename}.xlsx`);
};

// eslint-disable-next-line
const prepareRows = (rows: Record<string, any>[]) => {
  return rows.map((row) => ({
    Bet_ID: row.bet_id,
    login3: row.login3,
    agent: row.agent,
    agent_code: row.agent_code,
    player: row.player,
    "Sport KO": row.ko,
    League: row.league,
    Home: row.home,
    Away: row.away,
    Market: row.market,
    Bet: row.bet,
    Line: row.line,
    Odds: row.odds,
    odds_type: row.odds_type,
    Stake: row.stake,
    valid_stake: row.valid_stake,
    Bet_Result: row.bet_result,
    Period: row.period,
    Final_score: row.final_score,
    PNL: row.pnl,
    "AG_%": row["ag_%"],
    hit_time: row.hit_time,
    Cancel_Reason: row.cancel_reason,
    WeekNumber: row.weeknumber,
  }));
};
